module.exports = function SessionPropertiesEventBatch(cid, events) {
    this.cid = cid;
    this.events = events;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-properties-event-batch.js
// module id = 528
// module chunks = 1